"use client";

import { useSession } from "@/components/SupabaseProvider";
import Link from "next/link";
import { forwardRef } from "react";
import { twMerge } from "tailwind-merge";
import { useLocalizedHref, useMessages } from "../context/i18n";
import { useIsMarketingPage } from "../context/marketingPageContext";
import { nav as enNav } from "../dictionaries/en/nav";
import Button from "./Button";
import Logo from "./Logo";
import Nav from "./Nav";
import UserNav from "./UserNav";
import CalendarNavLink from "./autoPublish/CalendarNavLink";

interface HeaderProps {
  className?: string;
}

const Header = forwardRef<HTMLElement, HeaderProps>(
  function Header(props, ref) {
    const session = useSession();
    const isMarketingPage = useIsMarketingPage();
    const m = useMessages("nav", enNav);
    const href = useLocalizedHref();

    return (
      <header
        ref={ref}
        className={twMerge(
          "h-12 sticky top-0 w-full z-40 bg-white dark:bg-background",
          props.className,
        )}
      >
        <div className="max-w-[1500px] px-3 xl:px-12 grid grid-cols-[1fr_auto_auto] md:grid-cols-[1fr_auto_1fr] items-center mx-auto h-full gap-3">
          <Link href={session ? "/spaces" : href("/")} aria-label={m.homeLabel}>
            <Logo />
          </Link>

          <div className="flex items-center justify-center">
            {isMarketingPage && <Nav />}

            {session && !isMarketingPage && (
              <ul className="gap-2 truncate hidden md:flex">
                <li>
                  <Link className="truncate" href={"/spaces"}>
                    <Button size="m" variant="tertiary" className="truncate">
                      Videos
                    </Button>
                  </Link>
                </li>
                <li>
                  <CalendarNavLink />
                </li>
                <li>
                  <Link className="truncate" href={"/analytics"}>
                    <Button size="m" variant="tertiary" className="truncate">
                      Analytics
                    </Button>
                  </Link>
                </li>
              </ul>
            )}
          </div>

          <UserNav className="ml-auto" />
        </div>
      </header>
    );
  },
);

export default Header;
